import {
  updateResourceState,
  createResourceReducer,
  RESOURCE,
  normalizeResourceState
} from 'react-structure-admin';
import {
  OPENFINANCIALEXCHANGE,
  OPENFINANCIALEXCHANGE_CHANGE_CONCILIATION,
  OPENFINANCIALEXCHANGE_CHANGE_CONCILIATION_FINISHED,
  OPENFINANCIALEXCHANGE_CONCILIATIONS,
  OPENFINANCIALEXCHANGE_CONCILIATIONS_FINISHED,
  OPENFINANCIALEXCHANGE_FILE_IMPORT,
  OPENFINANCIALEXCHANGE_FILE_IMPORT_FINISHED,
  OPENFINANCIALEXCHANGE_TRANSACTIONS,
  OPENFINANCIALEXCHANGE_TRANSACTIONS_FINISHED,
  OPENFINANCIALEXCHANGE_TRANSACTIONS_QUERYPARAMS,
  OPENFINANCIALEXCHANGE_UPDATE_TRANSACTION
} from './openFinancialExchangeActions';

const handleError = (state, action) => {
  const errors =
    action.payload && action.payload.errors ? action.payload.errors || [] : [];

  return updateResourceState(state, action, RESOURCE, () => ({
    saving: false,
    loading: false,
    importingFile: false,
    loadingConciliationId: null,
    errors
  }));
};

const openFinancialExchangeReducer = createResourceReducer(
  OPENFINANCIALEXCHANGE,
  [],
  {
    [OPENFINANCIALEXCHANGE_FILE_IMPORT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        importingFile: true
      }));
    },

    [OPENFINANCIALEXCHANGE_FILE_IMPORT_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false,
        importingFile: false
      }));
    },

    [OPENFINANCIALEXCHANGE_TRANSACTIONS_QUERYPARAMS](state, action) {
      const newState = normalizeResourceState(state, action.resource);
      return updateResourceState(newState, action, RESOURCE, () => ({
        queryParams: action.payload,
        loaded: false
      }));
    },

    [OPENFINANCIALEXCHANGE_TRANSACTIONS](state, action) {
      const newState = normalizeResourceState(state, action.resource);
      return updateResourceState(newState, action, RESOURCE, () => ({
        loading: true,
        queryParams: action.payload
      }));
    },

    [OPENFINANCIALEXCHANGE_TRANSACTIONS_FINISHED](state, action) {
      const newState = normalizeResourceState(state, action.resource);

      return updateResourceState(
        newState,
        action,
        RESOURCE,
        ({ pagination }) => ({
          pagination: {
            ...pagination,
            total: action.payload.data.result.totalCount,
            current: Number(action.payload.config.params.page) || 1,
            pageSize: action.payload.data.result.pageSize,
            pageCount: action.payload.data.result.pageCount,
            showSizeChanger: false
          },
          ...action.payload.data.result,
          loaded: true,
          saving: false,
          loading: false
        })
      );
    },

    [OPENFINANCIALEXCHANGE_UPDATE_TRANSACTION](state, action) {
      return updateResourceState(state, action, RESOURCE, ({ items = [] }) => ({
        items: items.map((c) =>
          c.id === action.payload.id ? action.payload : c
        )
      }));
    },

    [OPENFINANCIALEXCHANGE_CONCILIATIONS](state, action) {
      const newState = normalizeResourceState(state, action.resource);
      return updateResourceState(newState, action, RESOURCE, () => ({
        loading: true,
        queryParams: action.payload
      }));
    },

    [OPENFINANCIALEXCHANGE_CONCILIATIONS_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        items: action.payload.data.result,
        loaded: true,
        saving: false,
        loading: false
      }));
    },

    [OPENFINANCIALEXCHANGE_CHANGE_CONCILIATION](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loadingConciliationId: action.payload.transaction.id
      }));
    },

    [OPENFINANCIALEXCHANGE_CHANGE_CONCILIATION_FINISHED](state, action) {
      const conciliation = action.payload.data.result;

      return updateResourceState(state, action, RESOURCE, ({ items = [] }) => ({
        loadingConciliationId: null,
        items: items.map((c) =>
          c.transaction.id === conciliation.transaction.id ? conciliation : c
        )
      }));
    }
  },
  handleError
);

export default openFinancialExchangeReducer;
